"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveFile = exports.getIsPdf = void 0;
var getIsPdf = exports.getIsPdf = function getIsPdf(file) {
  return file.type === 'application/pdf';
};
var saveFile = exports.saveFile = function saveFile(file, fileName) {
  var a = document.createElement('a');
  var url = window.URL.createObjectURL(file);
  a.href = url;
  a.rel = 'noopener noreferrer';
  a.download = fileName; // fileName with extension
  a.target = '_blank';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};